import Vue from "vue";

export const AvailabilitiesState = {
  room: null,
  rooms: [],
  totalRooms: 0,
  availabilityRooms: [],
  //
  availabilities: [],
  timeslots: [],
  availabilityTimeslots: [],
  totalScheduledDuration: 0,
  //
  availabilityTherapistTimeslots: [], // { user, data: { room, timeslots[] }[] }[]
  //
  appointment: null,
  appointments: [],
  totalAppointments: 0,
  //
  bookingAppointment: null,
  bookingTimeslots: [],
  //
  centerReasonSettings: [],
  totalCenterReasonSettings: 0
};

export const AvailabilitiesGetters = {
  room: state => {
    return state.room;
  },
  rooms: state => {
    return state.rooms;
  },
  totalRooms: state => {
    return state.totalRooms;
  },
  availabilityRooms: state => {
    return state.availabilityRooms;
  },
  //
  availabilities: state => {
    return state.availabilities;
  },
  timeslots: state => {
    return state.timeslots;
  },
  availabilityTimeslots: state => {
    return state.availabilityTimeslots;
  },
  totalScheduledDuration: state => {
    return state.totalScheduledDuration;
  },
  availabilityTherapistTimeslots: state => {
    return state.availabilityTherapistTimeslots;
  },
  //
  appointment: state => {
    return state.appointment;
  },
  appointments: state => {
    return state.appointments;
  },
  totalAppointments: state => {
    return state.totalAppointments;
  },
  //
  bookingAppointment: state => {
    return state.bookingAppointment;
  },
  bookingTimeslots: state => {
    return state.bookingTimeslots;
  },
  //
  centerReasonSettings: state => {
    return state.centerReasonSettings;
  },
  totalCenterReasonSettings: state => {
    return state.totalCenterReasonSettings;
  }
};

export const AvailabilitiesMutations = {
  setRoom: (state, data) => {
    if (data) {
      const index = state.rooms.findIndex(
        i => Number(i.id) === Number(data.id)
      );
      if (index > -1) {
        const arr = [...state.rooms];
        arr[index] = data;
        Vue.set(state, "rooms", arr);
      }
    }
    Vue.set(state, "room", data);
  },
  setRooms: (state, data) => {
    Vue.set(state, "rooms", data.rooms);
    Vue.set(state, "totalRooms", data.total_count);
  },
  addRoom: (state, data) => {
    Vue.set(state, "rooms", [...state.rooms, data]);
    Vue.set(state, "totalRooms", state.totalRooms + 1);
  },
  removeRoom: (state, data) => {
    const arr = state.rooms.filter(i => Number(i.id) !== Number(data.id));
    Vue.set(state, "rooms", arr);
    Vue.set(state, "totalRooms", state.totalRooms - 1);
  },
  setAvailabilityRooms: (state, data) => {
    Vue.set(state, "availabilityRooms", data.rooms);
  },
  //
  setAvailabilities: (state, data) => {
    Vue.set(state, "availabilities", data);
  },
  setTimeslots: (state, data) => {
    Vue.set(state, "timeslots", data.data);
    Vue.set(state, "totalScheduledDuration", data.total_scheduled_duration);
  },
  setAvailabilityTimeslots: (state, data) => {
    const rooms = [];
    const timeslots = [];
    data.forEach(i => {
      if (i.room) rooms.push(i.room);
      i.timeslots.forEach(slot => {
        timeslots.push(slot);
      });
    });
    Vue.set(state, "availabilityRooms", rooms);
    Vue.set(state, "availabilityTimeslots", timeslots);
  },
  setAvailabilityTherapistTimeslots: (state, data) => {
    Vue.set(state, "availabilityTherapistTimeslots", data);
  },
  //
  setAppointment: (state, data) => {
    Vue.set(state, "appointment", data);
  },
  setAppointments: (state, data) => {
    Vue.set(state, "appointments", data.appointments || []);
    Vue.set(state, "totalAppointments", data.total_count);
  },
  //
  setBookingAppointment: (state, data) => {
    Vue.set(state, "bookingAppointment", data);
    Vue.set(state, "bookingTimeslots", (data && data.appointments) || []);
  },
  removeBookingTimeslot: (state, data) => {
    const arr = state.bookingTimeslots.filter(
      i => Number(i.recurring_appointment_id) !== Number(data.id)
    );
    Vue.set(state, "bookingTimeslots", arr);
  },
  //
  setCenterReasonSetting: (state, data) => {
    if (data) {
      const index = state.centerReasonSettings.findIndex(
        i => Number(i.id) === Number(data.id)
      );
      if (index > -1) {
        const arr = [...state.centerReasonSettings];
        arr[index] = data;
        Vue.set(state, "centerReasonSettings", arr);
      }
    }
  },
  setCenterReasonSettings: (state, data) => {
    Vue.set(state, "centerReasonSettings", data.reasons);
    Vue.set(state, "totalCenterReasonSettings", data.total_count);
  },
  addCenterReasonSetting: (state, data) => {
    const arr = [data, ...state.centerReasonSettings];
    const total = state.totalCenterReasonSettings + 1;
    Vue.set(state, "centerReasonSettings", arr);
    Vue.set(state, "totalCenterReasonSettings", total);
  },
  removeCenterReasonSetting: (state, data) => {
    const arr = state.centerReasonSettings.filter(
      i => Number(i.id) !== Number(data.id)
    );
    const total = state.totalCenterReasonSettings - 1;
    Vue.set(state, "centerReasonSettings", arr);
    Vue.set(state, "totalCenterReasonSettings", total);
  }
};

export const AvailabilitiesActions = {
  getRooms: ({ commit, dispatch }, data = {}) => {
    const params = data.params || "";
    /*
      check room availability
        { date: YYYY-MM-DD, start_time: HH:mm, end_time: HH:mm }
    */
    return Vue.axios.secured
      .get(`/api/v1/rooms${params}`)
      .then(response => {
        if (params) {
          commit("setAvailabilityRooms", response.data);
        } else commit("setRooms", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch rooms from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  getRoom: ({ commit, dispatch }, data = {}) => {
    if (!data.id) {
      commit("setRoom", null);
      return { success: false, data: null };
    }
    return Vue.axios.secured
      .get(`/api/v1/rooms/${data.id}`)
      .then(response => {
        commit("setRoom", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch room from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  createRoom: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post(`/api/v1/rooms`, { room: data.room })
      .then(response => {
        commit("addRoom", response.data);
        const title = "New room created";
        const name = response.data.name;
        const message = `Success! <b>${name}</b> has been created.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to create room.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateRoom: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/rooms/${data.id}`, { room: data.room })
      .then(response => {
        commit("setRoom", response.data);
        const title = "Room updated";
        const name = response.data.name;
        const message = `Success! <b>${name}</b> has been updated.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update room.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  deleteRoom: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/rooms/${data.id}`)
      .then(response => {
        commit("removeRoom", data);
        const title = "Room deleted";
        const name = data.name;
        const message = `Success! <b>${name}</b> has been deleted.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to delete room.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  //
  getAvailabilities: ({ commit, dispatch }, data = {}) => {
    const params = data.params || "";
    /*
      BY ROOM
        DAILY   { room_id: 1, date: 2024-05-20, type: daily, user_id: '1,2,open_room' }
        WEEKLY  { room_id: 1, date: 2024-05-20, type: weekly }
      BY THERAPIST
        WEEKLY  { user_id: 1, date: 2024-05-20, type: weekly }
    */
    commit("setAvailabilities", []);
    return Vue.axios.secured
      .get(`/api/v1/availabilities${params}`)
      .then(response => {
        commit("setAvailabilities", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch availabilities from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  getAvailability: ({ commit, dispatch }, data = {}) => {
    const params = data.params || "";
    return Vue.axios.secured
      .get(`/api/v1/availabilities/${data.id}${params}`)
      .then(response => {
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch availability from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  createAvailabilities: ({ dispatch }, data = {}) => {
    return Vue.axios.secured
      .post(`/api/v1/availabilities`, { availability: data.availability })
      .then(response => {
        const title = "New availability added";
        const message =
          data.message ||
          `Success! The availability slot(s) have been added for <b>${data.room_name}</b>.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        console.error(error.response);
        const err = error.response.data.error || {
          conflicted_dates: {
            conflicted_by_room: [],
            conflicted_by_user: []
          }
        };
        const conflictedByRoom = err.conflicted_dates.conflicted_by_room;
        const conflictedByUser = err.conflicted_dates.conflicted_by_user;
        return {
          success: false,
          data: null,
          conflicted_by_room: conflictedByRoom || [],
          conflicted_by_user: conflictedByUser || []
        };
      });
  },
  updateAvailabilities: ({ dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/availabilities/${data.id}`, {
        availability: data.availability
      })
      .then(response => {
        const title = "Availability updated";
        const message =
          data.message ||
          `Success! The availability slot(s) for <b>${data.room_name}</b> have been updated.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        console.error(error.response);
        const err = error.response.data.error || {
          conflicted_dates: {
            conflicted_by_room: [],
            conflicted_by_user: []
          }
        };
        const conflictedByRoom = err.conflicted_dates.conflicted_by_room;
        const conflictedByUser = err.conflicted_dates.conflicted_by_user;
        return {
          success: false,
          data: null,
          conflicted_by_room: conflictedByRoom || [],
          conflicted_by_user: conflictedByUser || []
        };
      });
  },
  deleteAvailabilities: ({ dispatch }, data = {}) => {
    const params = data.params || "";
    return Vue.axios.secured
      .delete(`/api/v1/availabilities/${data.id}${params}`)
      .then(response => {
        const title = "Availability deleted";
        const message =
          data.message ||
          `Success! The availability slot(s) for <b>${data.therapist_name}</b> have been deleted.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: data };
      })
      .catch(error => {
        console.error(error.response);
        return {
          success: false,
          data: null,
          appointments: error.response.data.error.appointments || []
        };
      });
  },
  getTimeslots: ({ commit, dispatch }, data = {}) => {
    const params = data.params || "";
    const availability = data.availability || false;
    const byTherapist = params.includes("group_by=therapist") || false;
    /*
      ALL CALENDAR
        DAILY   { date: 2024-05-20, type: daily, user_id: '1,2,3', booked: true/false }
      BY THERAPIST CALENDAR
        WEEKLY  { user_id: 1, date: 2024-05-20, type: weekly }
      BY ROOM CALENDAR
        WEEKLY  { room_id: 1, date: 2024-05-20, type: weekly }
      FOR RESCHEDULE || availability: true
        { user_id: 1, date: 2024-05-20, room_id: 1 }
        { group_by: therapist, date: 2024-05-20, sort: alphabetical, client_id: 1 }
    */
    if (availability || byTherapist) {
      commit("setAvailabilityTimeslots", []);
      commit("setAvailabilityTherapistTimeslots", []);
    } else commit("setTimeslots", { total_scheduled_duration: 0, data: [] });
    return Vue.axios.secured
      .get(`/api/v1/timeslots${params}`)
      .then(response => {
        if (availability) {
          commit("setAvailabilityTimeslots", response.data.data);
        } else if (byTherapist) {
          commit("setAvailabilityTherapistTimeslots", response.data);
        } else commit("setTimeslots", response.data);
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch timeslots from server.";
        dispatch("showToast", { message, type: "error" });
      });
  },
  getTherapistOpenRoom: ({ dispatch }, data = {}) => {
    const params = data.params || "";
    /*
      { client_id: 1, room_id: 1, date: 2024-05-20, start_time: 09:00, end_time: 09:00  }
    */
    return Vue.axios.secured
      .get(`/api/v1/open_room_therapists${params}`)
      .then(response => {
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        console.error(err);
        return { success: false, data: null };
      });
  },
  getSupervisors: ({ dispatch }, data = {}) => {
    const params = data.params || "";
    /*
      { client_id: 1 }
    */
    return Vue.axios.secured
      .get(`/api/v1/supervisors${params}`)
      .then(response => {
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        console.error(err);
        return { success: false, data: null };
      });
  },
  //
  getAppointments: ({ commit, dispatch }, data = {}) => {
    const params = data.params || "";
    /*
      ALL LIST  {
        page: 1, per_page: 25, query: 'name',
        client_id: '1,2,3', user_id: '1,2,3', room_id: '1,2,3',
        start_date: 2024-05-20, end_date: 2024-06-20,
        status: 'scheduled,cancelled,in_progress,completed'
      }
      BY THERAPIST LIST {
        page: 1, per_page: 25, user_id: 1, query: 'name',
        client_id: '1,2,3', room_id: '1,2,3',
        start_date: 2024-05-20, end_date: 2024-06-20,
        status: 'scheduled,cancelled,in_progress,completed'
      }
      BY ROOM LIST  {
        page: 1, per_page: 25, room_id: 1, query: 'name',
        client_id: '1,2,3', user_id: '1,2,3',
        start_date: 2024-05-20, end_date: 2024-06-20,
        status: 'scheduled,cancelled,in_progress,completed'
      }
    */
    commit("setAppointments", []);
    return Vue.axios.secured
      .get(`/api/v1/appointments${params}`)
      .then(response => {
        commit("setAppointments", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch appointments from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  getAppointment: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .get(`/api/v1/appointments/${data.id}`)
      .then(response => {
        commit("setAppointment", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch appointment from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  exportAppointments: ({ dispatch }, data = {}) => {
    const params = data.params || "";
    /*
      ALL LIST  {
        query: 'name',
        client_id: '1,2,3', user_id: '1,2,3', room_id: '1,2,3',
        start_date: 2024-05-20, end_date: 2024-06-20,
        status: 'scheduled,cancelled,in_progress,completed'
      }
      BY THERAPIST LIST {
        show_by: therapist, user_id: 1, query: 'name',
        client_id: '1,2,3', room_id: '1,2,3',
        start_date: 2024-05-20, end_date: 2024-06-20,
        status: 'scheduled,cancelled,in_progress,completed'
      }
      BY ROOM LIST  {
        show_by: room, room_id: 1, query: 'name',
        client_id: '1,2,3', user_id: '1,2,3',
        start_date: 2024-05-20, end_date: 2024-06-20,
        status: 'scheduled,cancelled,in_progress,completed'
      }
    */
    return Vue.axios.secured
      .get(`/api/v1/appointments/export${params}`, { responseType: "blob" })
      .catch(error => {
        const err = error.response && error.response.data;
        console.error(err);
        const message = "Unable to export appointments.";
        dispatch("showToast", { message, type: "error" });
      });
  },
  createRecurringAppointments: ({ dispatch }, data = {}) => {
    const hideToast = data.hideToast || false;
    return Vue.axios.secured
      .post(`/api/v1/recurring_appointments`, data.params)
      .then(response => {
        const title = data.timeslots || "New appointment added";
        const message =
          data.message || `Success! appointments have been added.`;
        if (!hideToast) {
          dispatch("showToast", { title, message, type: "success" });
        }
        return { success: true, data: response.data };
      })
      .catch(error => {
        // error.response.statusText: "Unprocessable Entity"
        console.error(error.response);
        if (!error.response) {
          // const title = data.timeslots || "New appointment added";
          // const message =
          //   data.message || `Success! appointments have been added.`;
          // if (!hideToast) {
          //   dispatch("showToast", { title, message, type: "success" });
          // }
          return { success: true, data: "refetch" };
        }
        const err = (error.response &&
          error.response.data &&
          error.response.data.error) || {
          timeslots: {}
        };
        const timeslots = err.timeslots || {};
        const unavailableTimeslots = [
          ...(err.unavailable_timeslots || []),
          ...(timeslots.unavailable_timeslots || [])
        ];
        const unavailableTherapist = [
          ...(err.unavailable_therapist || []),
          ...(timeslots.unavailable_therapist || [])
        ];
        return {
          success: false,
          data: null,
          unavailable_timeslots: unavailableTimeslots,
          unavailable_therapist: unavailableTherapist
        };
      });
  },
  rescheduleAppointment: ({ dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/appointments/${data.id}/reschedule`, data.params)
      .then(response => {
        const title = "Appointment rescheduled";
        const message = `Success! The appointment slot for ${data.client_name} has been rescheduled.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        console.error(error.response);
        const err = error.response && error.response.data;
        const message = err || "Unable to reschedule appointment.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  reassignAppointment: ({ dispatch }, data = {}) => {
    const showToast = !data.params.check || false;
    return Vue.axios.secured
      .patch(`/api/v1/appointments/${data.id}/reassign`, data.params)
      .then(response => {
        if (showToast) {
          const title = "Appointment reassigned";
          const message = `Success! The appointment slot for ${data.client_name} has been reassigned.`;
          dispatch("showToast", { title, message, type: "success" });
        }
        return { success: true, data: response.data };
      })
      .catch(error => {
        console.error(error.response);
        const err = error.response.data.error || {
          conflicted_dates: [],
          total_success: 0
        };
        return {
          success: false,
          data: null,
          conflicted_dates: err.conflicted_dates,
          total_success: err.total_success
        };
      });
  },
  cancelAppointment: ({ dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/appointments/${data.id}/cancel`, data.params)
      .then(response => {
        const title = "Appointment cancelled";
        const message = `Success! ${data.slot_count} appointment slot(s) for ${data.client_name} has been cancelled.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        console.error(error.response);
        const err = error.response && error.response.data;
        const message = err || "Unable to cancel appointment.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  //
  getBookingAppointment: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .get(`/api/v1/booking_appointments/${data.id}`)
      .then(response => {
        commit("setBookingAppointment", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message =
          err || "Unable to fetch booking appointment from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  createBookingAppointment: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post(`/api/v1/booking_appointments`, {
        booking_appointment: data.booking_appointment,
        recurring_appointment: data.recurring_appointment
      })
      .then(response => {
        commit("setBookingAppointment", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to create booking appointment.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateBookingAppointment: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/booking_appointments/${data.id}`, {
        recurrence_settings: data.recurrence_settings
      })
      .then(response => {
        commit("setBookingAppointment", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update booking appointment.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  extendTimeBookingAppointment: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/booking_appointments/${data.id}/extend_time`, {
        recurrence_settings: data.recurrence_settings
      })
      .then(response => {
        commit("setBookingAppointment", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to extend time booking appointment.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  deleteBookingAppointment: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/booking_appointments/${data.id}`)
      .then(response => {
        commit("setBookingAppointment", null);
        return { success: true, data: data };
      })
      .catch(error => {
        console.error(error);
        // const err = error.response && error.response.data;
        // const message = err || "Unable to delete booking appointment.";
        // dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  createBookingTimeslot: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post(`/api/v1/recurring_appointments`, {
        recurring_appointment: data.recurring_appointment
      })
      .then(response => {
        return { success: true, data: response.data };
      })
      .catch(error => {
        console.error(error.response);
        return {
          success: false,
          data: null,
          errors: error.response.data.error || {}
        };
      });
  },
  updateBookingTimeslot: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/recurring_appointments/${data.id}`, {
        recurring_appointment: data.recurring_appointment
      })
      .then(response => {
        return { success: true, data: response.data };
      })
      .catch(error => {
        console.error(error.response);
        return {
          success: false,
          data: null,
          errors: error.response.data.error || {}
        };
      });
  },
  deleteBookingTimeslot: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/recurring_appointments/${data.id}`)
      .then(response => {
        commit("removeBookingTimeslot", data);
        return { success: true, data: data };
      })
      .catch(error => {
        console.error(error);
        // const err = error.response && error.response.data;
        // const message = err || "Unable to delete booking timeslot.";
        // dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  //
  getCenterReasonSettings: ({ commit, dispatch }, data = {}) => {
    const params = data.params || "";
    return Vue.axios.secured
      .get(`/api/v1/center_reason_settings${params}`)
      .then(response => {
        commit("setCenterReasonSettings", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message =
          err || "Unable to fetch center reason settings from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  createCenterReasonSetting: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post("/api/v1/center_reason_settings", { reason: data.reason })
      .then(response => {
        commit("addCenterReasonSetting", response.data);
        const title = `New reason added`;
        const message = `Success! New reason has been added.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to create center reason setting.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateCenterReasonSetting: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/center_reason_settings/${data.id}`, {
        reason: data.reason
      })
      .then(response => {
        commit("setCenterReasonSetting", response.data);
        const title = `Reason updated`;
        const message = `Success! The reason has been updated.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update center reason setting.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  deleteCenterReasonSetting: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/center_reason_settings/${data.id}`)
      .then(response => {
        commit("removeCenterReasonSetting", data);
        const title = `Reason deleted`;
        const message = `Success! The reason has been deleted.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to delete center reason setting.";
        dispatch("showToast", { message, type: "error" });
        return { success: false };
      });
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/availabilities.store.js